export const SPORTS_BET_NAMES: Record<string, string> = {
    "F/3": "Trixie Bet",
    "F/4": "Yankee Bet",
    "F/5": "Canadian Bet",
    "F/6": "Heinz Bet",
    "F/7": "Super Heinz Bet",
    "F/8": "Goliath Bet",
    "FS/3": "Patent Bet",
    "FS/4": "Lucky 15 Bet",
    "FS/5": "Lucky 31 Bet",
    "FS/6": "Lucky 63 Bet",
    ComboBet: "Combo",
    SystemBet: "System",
};

export const SYSTEM_BITMAPS: Record<string, number[]> = {
    "F/3": [0, 1, 1],
    "2/3": [0, 1, 0],
    "FS/3": [1, 1, 1],
    "2/4": [0, 1, 0, 0],
    "3/4": [0, 0, 1, 0],
    "F/4": [0, 1, 1, 1],
    "FS/4": [1, 1, 1, 1],
    "F/5": [0, 1, 1, 1, 1],
    "FS/5": [1, 1, 1, 1, 1],
    "3/5": [0, 0, 1, 0, 0],
    "3/6": [0, 0, 1, 0, 0, 0],
    "F/6": [0, 1, 1, 1, 1, 1],
    "FS/6": [1, 1, 1, 1, 1, 1],
    "F/7": [0, 1, 1, 1, 1, 1, 1],
    "FS/7": [1, 1, 1, 1, 1, 1, 1],
    "F/8": [0, 1, 1, 1, 1, 1, 1, 1],
    "FS/8": [1, 1, 1, 1, 1, 1, 1, 1],
    "2/9": [0, 1, 0, 0, 0, 0, 0, 0, 0],
    "3/9": [0, 0, 1, 0, 0, 0, 0, 0, 0],
    "2/10": [0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    "3/10": [0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    "2/11": [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    "3/11": [0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
};

export const FOLD_NAMES: Record<number, string> = {
    1: "Single",
    2: "Double",
    3: "Treble",
    4: "Four-fold",
    5: "Five-fold",
    6: "Six-fold",
    7: "Seven-fold",
    8: "Eight-fold",
};